export enum DOMAuthEvents {
  LOGOUT_ACTION = 'lk:auth:logout',
  FORM_AUTH_OPEN = 'form:auth:open',
  FORM_FORGOT_PASS_OPEN = 'form:forgotPass:open',
  FORM_FORGOT_PASS_CLOSE = 'form:forgotPass:close',
  FORM_REVERSE_PASSWORD_OPEN = 'form:reversePass:open',
  FORM_EXPRESS_REGISTRATION_OPEN = 'form:expressRegistration:open',
}
